function handleSpecialCodes(nirpp) {
  if (nirpp.indexOf('A') !== -1) {
    return {
      withoutLetters: nirpp.replace('A', '0'),
      offset: 1000000
    };
  }

  if (nirpp.indexOf('B') !== -1) {
    return {
      withoutLetters: nirpp.replace('B', '0'),
      offset: 2000000
    };
  }

  return {
    withoutLetters: nirpp,
    offset: 0
  };
}

function parse(nirpp) {
  var _handleSpecialCodes = handleSpecialCodes(nirpp),
      withoutLetters = _handleSpecialCodes.withoutLetters,
      offset = _handleSpecialCodes.offset;

  return parseInt(withoutLetters, 10) - offset;
}

function generateControlKey(nirpp) {
  return 97 - parse(nirpp) % 97;
}

function clean(nirpp) {
  return nirpp.toUpperCase().replace(/\s+/g, '');
}

function validCq(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof input !== 'string') throw new TypeError('Input should be a string');
  var shouldClean = options.shouldClean;
  var cleanedInput = shouldClean === false ? input : clean(input);
  var key = cleanedInput.slice(-2);
  var withoutKey = cleanedInput.slice(0, -2);
  var computedKey = generateControlKey(withoutKey);
  return computedKey == key;
}

module.exports = {
  validate: validCq
};